








import moment from 'moment';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from '../../core/components/Button.vue';
import ChatbotUserMessage from './ChatbotUserMessage.vue';
import ChatbotConversationEl from './ChatbotConversationEl.vue';
import ChatbotHeader from './ChatbotHeader.vue';
import ChatbotClearMessagesDialog from './ChatbotClearMessagesDialog.vue';
import { ID } from '../../../features/core/utils';
@Component({
    components: {
        Button,
        ChatbotUserMessage,
        ChatbotConversationEl,
        ChatbotHeader,
        ChatbotClearMessagesDialog
    }
})
export default class ChatbotWrapper extends Vue {
    clearConversation(){
        let chatbotConversationEl = this.$refs.chatbotConversationRef as HTMLFormElement;
        chatbotConversationEl.showClearHistoryConfirmation();
    }

    resendMessageWhenItFails(msg: string){
        let chatUserMsg = this.$refs.chatUserMessage as HTMLFormElement;
        chatUserMsg.submitMessageToServer(msg);
    }
}
